module.exports = __webpack_public_path__ + "media/images/icon/payment/master-card-text-97b491226045abf0df547443ce715da0.svg";